import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics'

let env = process.env.NODE_ENV
const { host } = window.location

if (localStorage.getItem('useProduction')) {
  env = localStorage.getItem('useProduction') === 'true' ? 'production' : 'development'
} else if (host === 'shop.dev.mitemma.de' || host === 'manage.dev.mitemma.de') {
  env = 'development'
}

console.log(`🚀 launching ${env}`) // eslint-disable-line

const config = {
  production: {
    apiKey: 'AIzaSyDiPpMNke1R4NO6lceOZrikDxhbw5O6z5M',
    authDomain: 'emma-shop.firebaseapp.com',
    databaseURL: 'https://emma-shop.firebaseio.com',
    projectId: 'emma-shop',
    storageBucket: 'emma-shop.appspot.com',
    messagingSenderId: '360155712466',
    appId: '1:360155712466:web:9b6c8329b3eba7020e960b',
    measurementId: 'G-6EPRXWP0W0'
  },
  development: {
    apiKey: 'AIzaSyAnSj0fTmxlpWMgeSXlZfkb_7RGo_3Bs1c',
    authDomain: 'emma-shop-dev.firebaseapp.com',
    databaseURL: 'https://emma-shop-dev.firebaseio.com',
    projectId: 'emma-shop-dev',
    storageBucket: 'emma-shop-dev.appspot.com',
    messagingSenderId: '42304600368',
    appId: '1:42304600368:web:45d42d6ff30ac784cff0f5'
  }
}

export const db = firebase.initializeApp(config[env]).firestore()

if (host === 'shop.mitemma.de') {
  firebase.analytics()
}

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}

db.enablePersistence({
  synchronizeTabs: true
})

export const auth = firebase.auth()
export const fb = firebase
